<template>
  <div>
    <el-dialog
      width="400px"
      center
      :title="collectTitle"
      class="collect"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="70px" size="small">
        <el-form-item label="名称" prop="Name">
          <el-input v-model="form.Name"></el-input>
        </el-form-item>
        <el-form-item label="路径">
          <el-scrollbar class="scrollbar">
            <el-tree
              ref="collectTree"
              @node-click="nodeClick"
              :props="props"
              :highlight-current="true"
              :data="treeData"
              :default-expanded-keys="keys"
              :current-node-key="nodeKey"
              node-key="NODEID"
              @node-contextmenu="nodeContextmenu"
              @node-expand="nodeExpand"
              @node-collapse="nodeCollapse"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span v-if="data.isAdd">
                  <el-input style="width:140px" v-model="appendName" size="mini"></el-input>
                  <el-button icon="el-icon-check" size="mini" circle></el-button>
                  <el-button icon="el-icon-close" size="mini" circle></el-button>
                </span>
                <span v-else>
                  <!--<i class="iconfont icon-zul" style="color: rgb(230, 162, 60);"></i>-->
                  <svg class="icon alSvgIcon" aria-hidden="true">
                    <use :xlink:href="'#'+getTaskTypeIcon(data)" />
                  </svg>
                  {{ node.label }}
                </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="append(false)" icon="el-icon-plus" plain>新建分组</el-button>
        <el-button type="danger" style="float: right;" @click="close">关 闭</el-button>
        <el-button type="primary" style="float: right;" @click="save('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="200"
      center
      :title="title+'分组'"
      :visible.sync="dialogRenameVisible"
      append-to-body
    >
      <el-form
        :model="formRename"
        :rules="rulesRename"
        ref="ruleFormRename"
        label-width="70px"
        size="small"
      >
        <el-form-item label="名称" prop="GroupName">
          <el-input v-model="formRename.GroupName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRename('ruleFormRename')">确 定</el-button>
        <el-button type="danger" @click="dialogRenameVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="Rename">重命名</v-contextmenu-item>
      <v-contextmenu-item @click="Delete">删除</v-contextmenu-item>
      <v-contextmenu-item @click="append(true)">新建分组</v-contextmenu-item>
    </v-contextmenu>
  </div>
</template>

<script>
// import selectTaskGroup from "@/components/basicData/selectTaskGroup.vue";
import folderApi from "@/api/modules/basicData/folder";
import { UpdateTreePathName } from "@/api/modules/basicData/basicTask";
import Linq from "linq";
import { mapMutations, mapState } from "vuex";
export default {
  components: {
    // selectTaskGroup
  },
  data() {
    return {
      collectTitle: "添加收藏",
      keys: [-3],
      nodeKey: -3,
      currentNode: {}, //选中当前行数据
      contexctmenu: {}, //右键值
      isContextmenu: false, //是否右键方式
      title: "修改",
      appendName: "",
      dialogVisible: false,
      dialogRenameVisible: false,
      isDisable: false,
      treeData: [],
      props: {
        label: "NODENAME",
        children: "children",
        isLeaf: "isLeaf"
      },
      formRename: {
        GroupName: "" //分组名称
      },
      form: {
        Name: "",
        Bookmark: "",
        RouteList: []
      },
      rulesRename: {
        GroupName: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      rules: {
        Name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        RouteList: [
          {
            type: "array",
            required: true,
            message: "请选择一个路径",
            trigger: "change"
          }
        ]
      }
    };
  },
  props: {
    taskContextMenu: {
      type: Object,
      default: () => {},
      require: true
    },
    taskName: String,
    Type: {
      //0：设置收藏 1:文件夹 2：修改
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      Person: state => state.folder.Person,
      userId: state => state.task.userId,
      userName: state => state.task.realName
    })
  },
  watch: {},
  methods: {
    openDialog(row) {
      this.dialogVisible = true;
      this.form.Name = this.taskName;
      this.GetMyTaskTreePath(row, true);
      this.$nextTick(() => {
        switch (this.Type) {
          case 0:
            this.collectTitle = "添加收藏";
            break;
          case 1:
            this.collectTitle = "添加分组";
            break;
          case 2:
            this.collectTitle = "移动到分组";
            break;
        }
      });
      // this.$nextTick(()=>{
      //   this.$$refs.collectTree.setCurrentKey(this.nodeKey);
      // });
    },
    getTaskTypeIcon(row) {
      let filter = this.$options.filters["taskStateIcon"];
      return row.NODETYPE == 2 || row.NODEID==-3? "icon-zul": row.NODETYPE == 3
        ? "icon-wenjianjia"
        : filter(row.RELATIONSTATE);
    },
    close() {
      this.dialogVisible = false;
    },
    save(formName) {
      console.log("currentNode", this.currentNode);

      this.isDisable = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          let folderList = [];
          let dt = new Date();
          let info = this.currentNode;
          
          if (info.NODEID == -3) {
            info.NODEID = null;
            info.NODENAME = null;
            info.NODETYPE = null;
            info.RELATIONID = null;
            info.RELATIONTYPE = null;
          }
          switch (this.Type) {
            case 2:
              this.moveCollect();
              break;
            default:
              folderList.push({
                NODEID: 0,
                NODETYPE:
                  this.Type === 1
                    ? 2
                    : this.taskContextMenu.TASKTYPE == "E9354DE41375"
                    ? 3
                    : 0,
                PermissionType: 0,
                UserId: this.userId,
                NODENAME: this.form.Name,
                CREATETIME: new Date(),
                PNODEID: this.currentNode.NODEID,
                PNODENAME: this.currentNode.NODENAME,
                PNODETYPE: this.currentNode.NODETYPE,
                PRELATIONID: this.currentNode.RELATIONID,
                PRELATIONTYPE: this.currentNode.RELATIONTYPE,
                RELATIONID: this.taskContextMenu.ID,
                RELATIONCREATETIME: new Date(this.taskContextMenu.CREATETIME),
                RELATIONTYPE: this.taskContextMenu.TASKTYPE,
                RELATIONTYPENAME: this.taskContextMenu.TASKTYPENAME,
                CREATEUSERID: this.userId,
                CREATEUSERNAME: this.userName,
                CHILDRENCOUNT: 0
              });
              folderApi.AddTaskTreePath(folderList).then(res => {
                if (res.ResultCode == 1) {
                  // this.GetMyTaskTreePath();
                  if (this.Type === 1) {
                    this.$emit("getNodeLoad", this.taskContextMenu);
                  }
                  this.close();
                } else {
                  this.$message.error("添加失败!");
                }
              });
              break;
          }
        } else {
          this.isDisable = false;
          return false;
        }
      });
    },
    moveCollect() {
      let pasteinfo = Object.assign({}, this.taskContextMenu);

      pasteinfo.PNODEID = this.currentNode.NODEID;
      pasteinfo.PNODENAME = this.currentNode.NODENAME;
      pasteinfo.PNODETYPE = this.currentNode.NODETYPE;
      pasteinfo.CREATETIME = new Date(pasteinfo.CREATETIME);

      pasteinfo.PRELATIONID = this.currentNode.RELATIONID;
      pasteinfo.PRELATIONTYPE = this.currentNode.RELATIONTYPE;
      pasteinfo.RELATIONCREATETIME = new Date(pasteinfo.RELATIONCREATETIME);

      folderApi.UpdateTaskTreePath([pasteinfo], this.Person).then(res => {
        if (res.ResultCode == 1) {
          this.$emit("getNodeLoad", this.taskContextMenu);
          this.close();
        } else {
          this.$message.error("移动失败!");
        }
      });
    },
    saveRename(formName) {
      this.isDisable = true;

      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.title == "添加") {
            let folderList = [];
            let info = this.isContextmenu
              ? this.contexctmenu
              : this.currentNode;
            if(info.NODEID==-3){
              info.NODEID=null;
              info.NODENAME=null;
              info.NODETYPE=null;
              info.RELATIONID=null;
              info.RELATIONTYPE=null;
            }
            folderList.push({
              NODEID: 0,
              NODETYPE: 2,
              PermissionType: 0,
              UserId: this.userId,
              NODENAME: this.formRename.GroupName, //分组名称,
              CREATETIME: new Date(),
              PNODEID: info.NODEID,
              PNODENAME: info.NODENAME,
              PNODETYPE: info.NODETYPE,
              PRELATIONID: info.RELATIONID,
              PRELATIONTYPE: info.RELATIONTYPE,
              CREATEUSERID: this.userId,
              CREATEUSERNAME: this.userName,
              CHILDRENCOUNT: 0
            });
            folderApi.AddTaskTreePath(folderList).then(res => {
              if (res.ResultCode == 1) {
                this.GetMyTaskTreePath();
                this.dialogRenameVisible = false;
              } else {
                this.$message.error("添加失败!");
              }
            });
          } else {
            this.contexctmenu.NODENAME = this.formRename.GroupName;

            let obj = {
              Name: this.formRename.GroupName,
              RelationId: this.contexctmenu.RELATIONID,
              NodeType: this.contexctmenu.NODETYPE
            };
            UpdateTreePathName(obj).then(res => {
              if (res.ResultCode > 0) {
                this.GetMyTaskTreePath();
                this.dialogRenameVisible = false;
              } else {
                this.$message.error("错误,请重试！");
              }
            });
          }
        } else {
          this.isDisable = false;
          return false;
        }
      });
    },
    GetTaskGroup(data) {
      console.info("任务组已选择:", data);
      if (data) {
        this.form.RouteList = data;
      } else {
        this.form.RouteList = [];
      }
    },
    GetMyTaskTreePath(row, isLoad) {
      folderApi.GetMyTaskTreePath(this.Person, true, 0).then(res => {
        if (!res) {
          this.treeData = [];
        } else {
          // let info = res.find(item => item.NODENAME == "个人");
          // info.NODENAME = "我的收藏";
          if (isLoad) {
            this.currentNode = res[0];
            console.log("currentNodeLoad", this.currentNode);
          }
          if (row) {
            if (row.NODETYPE !== 0) {
              this.keys = [row.NODEID];
              this.nodeKey = row.NODEID;
              this.nodeClick(row);
              setTimeout(() => {
                this.$refs.collectTree.setCurrentKey(row.NODEID);
              });
            }
          }
          this.treeData = res;
        }
      });
    },
    nodeContextmenu(ev, data, node, val) {
      this.contexctmenu = data;
      console.log("nodeContextmenu", data);
      //右击
      const postition = {
        top: ev.pageY,
        left: ev.pageX
      };
      this.$refs.contextmenu.show(postition);
    },
    Rename() {
      //重命名
      this.dialogRenameVisible = true;
      this.formRename.GroupName = this.contexctmenu.NODENAME;
      // let data = this.contexctmenu;
      // data.isAdd = false;
    },
    Delete() {
      //删除
      this.$confirm("确认删除？")
        .then(_ => {
          folderApi
            .DelTaskTreePath([this.contexctmenu], this.Person)
            .then(res => {
              if (res.ResultCode == 1) {
                // this.this.dialogRenameVisible=false;
                this.GetMyTaskTreePath();
                // this.$refs.collectTree.remove(this.contexctmenu)
              } else {
                this.$message.error("删除失败!");
              }
            });
        })
        .catch(_ => {});
    },
    append(isContextmenu) {
      this.isContextmenu = isContextmenu;
      let data = this.currentNode;
      // if(isContextmenu){
      //   this.title='修改'
      //   data = this.contexctmenu
      //   this.formRename.GroupName=data.NODENAME
      // }else{
      this.title = "添加";
      this.formRename.GroupName = "新建分组";
      // }
      this.dialogRenameVisible = true;
      // console.log("append", data);
      // const newChild = {
      //   NODEID: this.Guid(),
      //   PNODEID: data.NODEID,
      //   NODENAME: "测试",
      //   children: [],
      //   isAdd: true
      // }; //VirtualId: this.Guid(),PvirtualId:data.VirtualId,
      // if (!data.children) {
      //   this.$set(data, "children", []);
      // }
      // data.children.push(newChild);
    },
    nodeClick(data) {
      console.log("nodeClick", data);
      this.currentNode = data;
    },
    nodeExpand(data, node, current) {
      //展开
      this.keys.push(data.NODEID);
    },
    nodeCollapse(data, node, current) {
      //关闭
      var index = this.keys.indexOf(data.NODEID);
      if (index > -1) {
        this.keys.splice(index, 1);
      }
    }
  },
  created() {
    // this.GetMyTaskTreePath();
  }
};
</script>

<style lang="scss" scoped>
.collect {
  .alSvgIcon {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        fill: currentColor;
        overflow: hidden;
      }
  .scrollbar {
    height: 200px;
    /deep/ .el-scrollbar__wrap {
      overflow-x: scroll;
    }
  }
  .dialog-footer {
    text-align: left;
  }
  /deep/ .el-input--mini .el-input__inner {
    height: 20px;
    line-height: 20px;
  }
  /deep/ .el-button--mini.is-circle {
    padding: 4px;
  }
  /deep/ .el-dialog--center .el-dialog__body {
    text-align: initial;
    padding: 10px 15px 0px;
  }
}
</style>